export default __webpack_public_path__ + "static/blog8-2a944083bcfdc21d3b5d59d2c92644ee.jpg";